/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
export const authTokenSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-user:AuthToken',
    type: 'object',
    properties: {
        token: { type: 'string' },
        tokenType: { type: 'string', enum: ['Bearer', 'BearerCustomJwt', 'APIKey', 'Internal', 'TaskAuth'] }
    },
    required: ['token']
};
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-user:AuthToken" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.token === undefined && (missing0 = 'token')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.token !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.token !== 'string') {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/token',
                                schemaPath: '#/properties/token/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tokenType !== undefined) {
                        let data1 = data.tokenType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/tokenType',
                                    schemaPath: '#/properties/tokenType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'Bearer' ||
                            data1 === 'BearerCustomJwt' ||
                            data1 === 'APIKey' ||
                            data1 === 'Internal' ||
                            data1 === 'TaskAuth')) {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/tokenType',
                                    schemaPath: '#/properties/tokenType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema29.properties.tokenType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const orgSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-user:Org',
    type: 'object',
    properties: {
        ID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] }
    },
    required: ['ID', 'orgPlan']
};
const formats0 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-user:Org" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.ID === undefined && (missing0 = 'ID')) || (data.orgPlan === undefined && (missing0 = 'orgPlan'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.ID !== undefined) {
                    let data0 = data.ID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/ID',
                                            schemaPath: '#/properties/ID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/ID',
                                        schemaPath: '#/properties/ID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgPlan !== undefined) {
                        let data1 = data.orgPlan;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'Social' ||
                            data1 === 'Enterprise' ||
                            data1 === 'Integration' ||
                            data1 === 'Temp' ||
                            data1 === 'Starter' ||
                            data1 === 'Professional')) {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema30.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const userSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-user:User',
    type: 'object',
    properties: {
        ID: { type: 'string', minLength: 1, maxLength: 128 },
        auth: { $ref: 'urn:wisepipe-user:AuthToken' },
        loginType: { type: 'string' },
        name: { type: 'string' },
        email: { type: 'string' }
    },
    required: ['ID', 'auth']
};
const func2 = ucs2length;
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-user:User" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.ID === undefined && (missing0 = 'ID')) || (data.auth === undefined && (missing0 = 'auth'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.ID !== undefined) {
                    let data0 = data.ID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/ID',
                                        schemaPath: '#/properties/ID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/ID',
                                            schemaPath: '#/properties/ID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/ID',
                                    schemaPath: '#/properties/ID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.auth !== undefined) {
                        let data1 = data.auth;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.token === undefined && (missing1 = 'token')) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/auth',
                                            schemaPath: 'urn:wisepipe-user:AuthToken/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.token !== undefined) {
                                        const _errs6 = errors;
                                        if (typeof data1.token !== 'string') {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/auth/token',
                                                    schemaPath: 'urn:wisepipe-user:AuthToken/properties/token/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.tokenType !== undefined) {
                                            let data3 = data1.tokenType;
                                            const _errs8 = errors;
                                            if (typeof data3 !== 'string') {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/auth/tokenType',
                                                        schemaPath: 'urn:wisepipe-user:AuthToken/properties/tokenType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data3 === 'Bearer' ||
                                                data3 === 'BearerCustomJwt' ||
                                                data3 === 'APIKey' ||
                                                data3 === 'Internal' ||
                                                data3 === 'TaskAuth')) {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/auth/tokenType',
                                                        schemaPath: 'urn:wisepipe-user:AuthToken/properties/tokenType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema29.properties.tokenType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/auth',
                                        schemaPath: 'urn:wisepipe-user:AuthToken/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.loginType !== undefined) {
                            const _errs10 = errors;
                            if (typeof data.loginType !== 'string') {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/loginType',
                                        schemaPath: '#/properties/loginType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs10 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.name !== undefined) {
                                const _errs12 = errors;
                                if (typeof data.name !== 'string') {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs12 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.email !== undefined) {
                                    const _errs14 = errors;
                                    if (typeof data.email !== 'string') {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/email',
                                                schemaPath: '#/properties/email/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs14 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map